import { useEffect, useState } from 'react'
import axios from 'config/axios'

const useQuizAnswerPie = (taskCode?: string, campaignCode?: string, update?: boolean) => {
  const [data, setData] = useState<any>({
    completed_users: 0,
    stats: [],
  })
  const [loading, setLoading] = useState(false)
  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await axios.get(
        `/api/admin/space/campaign/analyze/answer?task_code=${taskCode}&campaign_code=${campaignCode}`,
      )
      setLoading(false)
      if (res.data.code === 0) setData(res.data.data)
    } catch (error) {
      console.error('useQuizAnswerPie --> ' + error)
    }
  }
  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, [taskCode, campaignCode, update])
  return [data, loading]
}

export default useQuizAnswerPie
